import { Observable } from 'rxjs';

export abstract class UafService {

  abstract getDeclaracion(): Observable<any>;

  abstract saveDeclaracion(formularioUaf: any): Observable<any>;

  abstract validaDeclaracionUaf(): Observable<boolean>;

}
